// test2495
(2495 && 0);
